module.exports = "<p>\n  service-management works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/DashboardPages/service-management/service-management.component.html
// module id = ./src/app/Dashboard/DashboardPages/service-management/service-management.component.html
// module chunks = main